import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { useRecoilValueLoadable } from 'recoil';
import parse from 'react-html-parser';
import { productLongDescriptionQueryFamily } from '../../../api/products/productDetail';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface ProductDetailSpagettyLongDescriptionProps
  extends StandardDivProps<ProductDetailSpagettyLongDescriptionClassKey> {
  anchor?: string;
  onNaviButtonShow?: (state?: boolean) => void;
  productId: string;
}

export type ProductDetailSpagettyLongDescriptionClassKey = 'root' | 'headline';

const themeSettings = { name: 'ProductDetailSpagettyLongDescription' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<ProductDetailSpagettyLongDescriptionClassKey, {}>({
      root: {},
      headline: {
        ...theme.typography.h4,
      },
    }),
  themeSettings,
);

const ProductDetailSpagettyLongDescription = React.forwardRef<
  HTMLDivElement,
  ProductDetailSpagettyLongDescriptionProps
>(({ anchor, className, classes: pClasses, onNaviButtonShow, productId }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const longDesriptionLoadable = useRecoilValueLoadable(productLongDescriptionQueryFamily(productId));
  const t = useTranslateWithFallback();

  React.useEffect(() => {
    if (longDesriptionLoadable.state === 'hasValue' && longDesriptionLoadable.contents) {
      if (onNaviButtonShow) onNaviButtonShow(true);
    }
  }, [longDesriptionLoadable.contents, longDesriptionLoadable.state, onNaviButtonShow]);

  return (
    <div ref={ref} className={clsx(classes.root, className)} id={anchor ? anchor.replace('#', '') : undefined}>
      {longDesriptionLoadable.state === 'hasValue' && longDesriptionLoadable.contents?.body && (
        <>
          <h2 className={classes.headline}>{t('productDetailPage/details')}</h2>
          {parse(longDesriptionLoadable.contents.body)}
        </>
      )}
    </div>
  );
});

ProductDetailSpagettyLongDescription.displayName = 'ProductDetailSpagettyLongDescription';

export default withThemeProps(themeSettings)(ProductDetailSpagettyLongDescription);
